import React from 'react';
import TabSelector from '../TabSelector/TabSelector';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { TabButtonProps } from '../TabButton/TabButton';
import PricingQuizAction, { PricingQuizActionPros } from '../PricingQuizAction/PricingQuizAction';
import PricingCardList, { PricingCardListProps } from 'molecules/PricingCardList/PricingCardList';

interface PricingCardsWithSelectionProps extends PricingCardListProps {
  tabs: TabButtonProps[];
  pricingQuiz?: PricingQuizActionPros;
}

const PricingCardsWithSelection = ({
  tabs,
  pricingCards,
  pricingQuiz,
  priceBlockMinHeight,
  totalColumns,
}: PricingCardsWithSelectionProps): JSX.Element => {
  return (
    <Stack
      direction='column'
      gap='spacing-7xl'
      gapSm='spacing-xl'
      justify='center'
      align='center'
    >
      <TabSelector tabs={tabs} />
      <Stack
        direction='column'
        gap='spacing-4xl'
        justify='center'
        align='center'
      >
        <PricingCardList
          pricingCards={pricingCards}
          priceBlockMinHeight={priceBlockMinHeight}
          totalColumns={totalColumns}
        />
        {pricingQuiz && <PricingQuizAction {...pricingQuiz} />}
      </Stack>
    </Stack>
  );
};

export default PricingCardsWithSelection;
